import React, { Component } from 'react';
import { func, string } from 'prop-types';
import { GlobalContext } from '@thd-olt-global/global-provider-component';
import CollectionPageComponent from '@thd-olt-pages/collection';
import { Redirect } from 'react-router-dom';
import LayoutManager from '@thd-olt-component/layout-manager';
import { environmentKey } from '../../constants/key-provider';

class CollectionPage extends Component {

  static contextType = GlobalContext;

  state = {
    error: null
  }

  handleError = (apiError) => {
    const { pathname } = this.props;
    if (typeof window !== 'undefined') {
      this.setState({ error: apiError });
    }
    return null;
  }
  render = () => {
    const {
      familyId,
      namespace,
      pathname,
      push,
      querystring,
      replace
    } = this.props;
    const { error } = this.state;
    const { channel, env } = this.context.request;
    const { localizationStatus, localStore } = this.context;
    const apiKey = environmentKey(env);
    if (error) {
      return <Redirect to={`/error${pathname}`} />;
    }
    return (
      <LayoutManager input={{ page: 'collections' }} name="Collage Browse/Search Page">
        <LayoutManager.Group name="Collections Page">
          <CollectionPageComponent
            apiKey={apiKey}
            channel={channel}
            env={env}
            familyId={familyId}
            localizationStatus={localizationStatus}
            localStore={localStore}
            namespace={namespace}
            onError={this.handleError}
            pathname={pathname}
            push={push}
            querystring={querystring}
            replace={replace}
          />
        </LayoutManager.Group>
      </LayoutManager>
    );
  }
}

CollectionPage.propTypes = {
  familyId: string.isRequired,
  namespace: string.isRequired,
  pathname: string.isRequired,
  push: func.isRequired,
  querystring: string,
  replace: func.isRequired
};

CollectionPage.defaultProps = {
  querystring: null
};

export default CollectionPage;
